module.exports = __webpack_public_path__ + "img/1567293270.f3b26f93.jpg";